export enum ResultAddNotification{
    AddSensorBoolean,
    AddSensorNumber,
    AddSensorString,
}